<template>
    <div class="py-44">
        <div class="container">
            <div class="mb-24">
                <h1
                    class="break-words font-display no-ligature"
                    style="
                        -webkit-hyphens: auto;
                        -ms-hyphens: auto;
                        hyphens: auto;
                    "
                >
                    ALLGEMEINE GESCH&Auml;FTSBEDINGUNGEN der
                </h1>
                <p class="m-0">
                    <strong>Raphael Bernhart</strong>
                    <br />
                    <span class="m-0">Achenweg 30</span>
                    <br />
                    <span class="m-0">6364 Brixen im Thale</span>
                    <br />
                    <span class="m-0">mail@raphaelbernhart.at</span>
                </p>
            </div>

            <h5 class="mt-16">1. &nbsp; &nbsp;Geltung, Vertragsabschluss</h5>
            <p class="p6">
                1.1 &nbsp; &nbsp;Die Leistungen von Raphael Bernhart gelten
                ausschlie&szlig;lich auf der Grundlage der nach-folgenden
                Allgemeinen Gesch&auml;ftsbedingungen (AGB). Diese gelten
                f&uuml;r alle Rechtsbeziehungen zwischen der Agentur und dem
                Kunden, selbst wenn nicht ausdr&uuml;cklich auf sie Bezug
                genommen wird. Die AGB sind ausschlie&szlig;lich f&uuml;r
                Rechtsbeziehung mit Unternehmern anwendbar, sohin B2B.
            </p>
            <p class="p6">
                1.2 &nbsp; &nbsp;Ma&szlig;geblich ist jeweils die zum Zeitpunkt
                des Vertragsschlusses g&uuml;ltige Fassung. Abweichungen von
                diesen sowie sonstige erg&auml;nzende Vereinbarungen mit dem
                Kunden sind nur wirksam, wenn sie von der Agentur schriftlich
                best&auml;tigt werden.
            </p>
            <p class="p6">
                1.3 &nbsp; &nbsp;Allf&auml;llige Gesch&auml;ftsbedingungen des
                Kunden werden, selbst bei Kenntnis, nicht akzeptiert, sofern
                nicht im Einzelfall ausdr&uuml;cklich und schriftlich anderes
                vereinbart wird. AGB des Kunden widerspricht die Agentur
                ausdr&uuml;cklich. Eines weiteren Widerspruchs gegen AGB des
                Kunden durch die Agentur bedarf es nicht.
            </p>
            <p class="p4">
                1.4 &nbsp; &nbsp;&Auml;nderungen der AGB werden dem Kunden
                bekannt gegeben und gelten als vereinbart, wenn der Kunde den
                ge&auml;nderten AGB nicht schriftlich binnen 14 Tagen
                widerspricht; auf die Bedeutung des Schweigens wird der Kunde in
                der Verst&auml;ndigung ausdr&uuml;cklich hingewiesen.
            </p>
            <p class="p6">
                1.5 &nbsp; &nbsp; Sollten einzelne Bestimmungen dieser
                Allgemeinen Gesch&auml;ftsbedingungen unwirksam sein, so
                ber&uuml;hrt dies die Verbindlichkeit der &uuml;brigen
                Bestimmungen und der unter ihrer Zugrundelegung geschlossenen
                Vertr&auml;ge nicht. Die unwirksame Bestimmung ist durch eine
                wirksame, die dem Sinn und Zweck am n&auml;chsten kommt, zu
                ersetzen.
            </p>
            <p class="p4">
                1.6 &nbsp; &nbsp;Die Angebote der Agentur sind freibleibend und
                unverbindlich.
            </p>
            <p class="p3"><br /></p>

            <h5 class="p4">2. &nbsp; &nbsp;Social Media Kan&auml;le</h5>
            <p class="p4">
                Die Agentur weist den Kunden vor Auftragserteilung
                ausdr&uuml;cklich darauf hin, dass die Anbieter von
                &bdquo;Social-Media-Kan&auml;len&ldquo; (z.B. facebook, im
                Folgenden kurz: Anbieter) es sich in ihren Nutzungsbedingungen
                vorbehalten, Werbeanzeigen und -auftritte aus beliebigen Grund
                abzulehnen oder zu entfernen. Die Anbieter sind demnach nicht
                verpflichtet, Inhalte und Informationen an die Nutzer
                weiterzuleiten. Es besteht daher das von der Agentur nicht
                kalkulierbare Risiko, dass Werbeanzeigen und -auftritte grundlos
                entfernt werden. Im Fall einer Beschwerde eines anderen Nutzers
                wird zwar von den Anbietern die M&ouml;glichkeit einer
                Gegendarstellung einger&auml;umt, doch erfolgt auch in diesem
                Fall eine sofortige Entfernung der Inhalte. Die Wiedererlangung
                des urspr&uuml;nglichen, rechtm&auml;&szlig;igen Zustandes kann
                in diesem Fall einige Zeit in Anspruch nehmen. Die Agentur
                arbeitet auf der Grundlage dieser Nutzungsbedingungen der
                Anbieter, auf die sie keinen Einfluss hat, und legt diese auch
                dem Auftrag des Kunden zu Grunde. Ausdr&uuml;cklich anerkennt
                der Kunde mit der Auftragserteilung, dass diese
                Nutzungsbedingungen die Rechte und Pflichten eines
                allf&auml;lligen Vertragsverh&auml;ltnisses (mit-)bestimmen. Die
                Agentur beabsichtigt, den Auftrag des Kunden nach bestem Wissen
                und Gewissen auszuf&uuml;hren und die Richtlinien von
                &bdquo;Social Media Kan&auml;len&ldquo; einzuhalten. Aufgrund
                der derzeit g&uuml;ltigen Nutzungsbedingungen und der einfachen
                M&ouml;glichkeit jedes Nutzers, Rechtsverletzungen zu behaupten
                und so eine Entfernung der Inhalte zu erreichen, kann die
                Agentur aber nicht daf&uuml;r einstehen, dass die beauftragte
                Kampagne auch jederzeit abrufbar ist.
            </p>
            <p class="p3"><br /></p>

            <h5 class="p7">3. &nbsp; &nbsp;Konzept- und Ideenschutz</h5>
            <p class="p8">
                <span class="s1">
                    Hat der potentielle Kunde
                    <span class="Apple-converted-space">&nbsp;&nbsp;</span>
                    die Agentur vorab bereits eingeladen, ein Konzept zu
                    erstellen, und kommt die Agentur dieser Einladung noch vor
                    Abschluss des Hauptvertrages nach, so gilt nachstehende
                    Regelung:
                </span>
            </p>
            <p class="p7">
                <span class="s1">
                    3.1 &nbsp; &nbsp;Bereits durch die Einladung und die Annahme
                    der Einladung durch die Agentur treten der potentielle Kunde
                    und die Agentur in ein Vertragsverh&auml;ltnis
                    (&bdquo;Pitching-Vertrag&ldquo;). Auch diesem Vertrag liegen
                    die AGB zu Grunde.
                    <span class="Apple-converted-space">&nbsp;</span>
                </span>
            </p>
            <p class="p7">
                <span class="s1">
                    3.2 &nbsp; &nbsp;Der potentielle Kunde anerkennt, dass die
                    Agentur bereits mit der Konzepterarbeitung kostenintensive
                    Vorleistungen erbringt, obwohl er selbst noch keine
                    Leistungspflichten &uuml;bernommen hat.
                    <span class="Apple-converted-space">&nbsp;</span>
                </span>
            </p>
            <p class="p7">
                <span class="s1">
                    3.3 &nbsp; &nbsp;Das Konzept untersteht in seinen
                    sprachlichen und grafischen Teilen, soweit diese
                    Werkh&ouml;he erreichen, dem Schutz des
                    Urheberrechtsgesetzes. Eine Nutzung und Bearbeitung dieser
                    Teile ohne Zustimmung der Agentur ist dem potentiellen
                    Kunden schon auf Grund des Urheberrechtsgesetzes nicht
                    gestattet.
                </span>
            </p>
            <p class="p7">
                <span class="s1">
                    3.4 &nbsp; &nbsp;Das Konzept enth&auml;lt dar&uuml;ber
                    hinaus werberelevante
                    <strong>Ideen</strong>
                    , die keine Werkh&ouml;he erreichen und damit nicht den
                    Schutz des Urheberrechtsgesetzes genie&szlig;en. Diese Ideen
                    stehen am Anfang jedes Schaffensprozesses und k&ouml;nnen
                    als z&uuml;ndender Funke alles sp&auml;ter Hervorgebrachten
                    und somit als Ursprung von Vermarktungsstrategie definiert
                    werden. Daher sind jene Elemente des Konzeptes
                    gesch&uuml;tzt, die eigenartig sind und der
                    Vermarktungsstrategie ihre charakteristische Pr&auml;gung
                    geben. Als Idee im Sinne dieser Vereinbarung werden
                    insbesondere Werbeschlagw&ouml;rter, Werbetexte, Grafiken
                    und Illustrationen, Werbemittel usw. angesehen, auch wenn
                    sie keine Werkh&ouml;he erreichen.
                </span>
            </p>
            <p class="p7">
                <span class="s1">
                    3.5 &nbsp; &nbsp;Der potentielle Kunde verpflichtet sich, es
                    zu unterlassen, diese von der Agentur im Rahmen des
                    Konzeptes pr&auml;sentierten kreativen Werbeideen
                    au&szlig;erhalb des Korrektivs eines sp&auml;ter
                    abzuschlie&szlig;enden Hauptvertrages wirtschaftlich zu
                    verwerten bzw. verwerten zu lassen oder zu nutzen bzw.
                    nutzen zu lassen.
                </span>
            </p>
            <p class="p7">
                <span class="s1">
                    3.6 &nbsp; &nbsp;Soferne der potentielle Kunde der Meinung
                    ist, dass ihm von der Agentur Ideen pr&auml;sentiert wurden,
                    auf die er bereits vor der Pr&auml;sentation gekommen ist,
                    so hat er dies der Agentur binnen 14 Tagen nach dem Tag der
                    Pr&auml;sentation per E-Mail unter Anf&uuml;hrung von
                    Beweismitteln, die eine zeitliche Zuordnung erlauben,
                    bekannt zu geben.
                    <span class="Apple-converted-space">&nbsp;</span>
                </span>
            </p>
            <p class="p7">
                <span class="s1">
                    3.7 &nbsp; &nbsp;Im gegenteiligen Fall gehen die
                    Vertragsparteien davon aus, dass die Agentur dem
                    potentiellen Kunden eine f&uuml;r ihn neue Idee
                    pr&auml;sentiert hat. Wird die Idee vom Kunden verwendet, so
                    ist davon auszugehen, dass die Agentur dabei verdienstlich
                    wurde.
                    <span class="Apple-converted-space">&nbsp; &nbsp;</span>
                </span>
            </p>
            <p class="p4">
                <span class="s1">
                    3.8 &nbsp; &nbsp;Der potentielle Kunde kann sich von seinen
                    Verpflichtungen aus diesem Punkt durch Zahlung einer
                    angemessenen Entsch&auml;digung zuz&uuml;glich 20 %
                    Umsatzsteuer befreien. Die Befreiung tritt erst nach
                    vollst&auml;ndigem Eingang der Zahlung der
                    Entsch&auml;digung bei der Agentur ein.
                    <span class="Apple-converted-space">&nbsp;</span>
                </span>
            </p>
            <p class="p3"><br /></p>

            <h5 class="p4">
                4. &nbsp; &nbsp;Leistungsumfang, Auftragsabwicklung und
                Mitwirkungspflichten des Kunden
            </h5>
            <p class="p6">
                4.1 &nbsp; &nbsp;Der Umfang der zu erbringenden Leistungen
                ergibt sich aus der Leistungsbeschreibung im Agenturvertrag oder
                einer allf&auml;lligen Auftragsbest&auml;tigung durch die
                Agentur, sowie dem allf&auml;lligen Briefingprotokoll
                (&bdquo;Angebotsunterlagen&ldquo;). Nachtr&auml;gliche
                &Auml;nderungen des Leistungsinhaltes bed&uuml;rfen der
                schriftlichen Best&auml;tigung durch die Agentur. Innerhalb des
                vom Kunden vorgegeben Rahmens besteht bei der Erf&uuml;llung des
                Auftrages Gestaltungsfreiheit der Agentur.
            </p>
            <p class="p6">
                4.2 &nbsp; &nbsp;Alle Leistungen der Agentur (insbesondere alle
                Vorentw&uuml;rfe, Skizzen, Reinzeichnungen,
                B&uuml;rstenabz&uuml;ge, Blaupausen, Kopien, Farbabdrucke und
                elektronische Dateien) sind vom Kunden zu &uuml;berpr&uuml;fen
                und von ihm binnen drei Werktagen ab Eingang beim Kunden
                freizugeben. Nach Verstreichen dieser Frist ohne
                R&uuml;ckmeldung des Kunden gelten sie als vom Kunden genehmigt.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p6">
                4.3 &nbsp; &nbsp;Der Kunde wird der Agentur zeitgerecht und
                vollst&auml;ndig alle Informationen und Unterlagen
                zug&auml;nglich machen, die f&uuml;r die Erbringung der Leistung
                erforderlich sind. Er wird sie von allen Umst&auml;nden
                informieren, die f&uuml;r die Durchf&uuml;hrung des Auftrages
                von Bedeutung sind, auch wenn diese erst w&auml;hrend der
                Durchf&uuml;hrung des Auftrages bekannt werden. Der Kunde
                tr&auml;gt den Aufwand, der dadurch entsteht, dass Arbeiten
                infolge seiner unrichtigen, unvollst&auml;ndigen oder
                nachtr&auml;glich ge&auml;nderten Angaben von der Agentur
                wiederholt werden m&uuml;ssen oder verz&ouml;gert werden.
            </p>
            <p class="p4">
                4.4 &nbsp; &nbsp;Der Kunde ist weiters verpflichtet, die
                f&uuml;r die Durchf&uuml;hrung des Auftrages zur Verf&uuml;gung
                gestellten Unterlagen (Fotos, Logos etc.) auf allf&auml;llige
                Urheber-, Marken-, Kennzeichenrechte oder sonstige Rechte
                Dritter zu pr&uuml;fen (Rechteclearing) und garantiert, dass die
                Unterlagen frei von Rechten Dritter sind und daher f&uuml;r den
                angestrebten Zweck eingesetzt werden k&ouml;nnen. Die Agentur
                haftet im Falle blo&szlig; leichter Fahrl&auml;ssigkeit oder
                nach Erf&uuml;llung ihrer Warnpflicht &ndash; jedenfalls im
                Innenverh&auml;ltnis zum Kunden - nicht wegen einer Verletzung
                derartiger Rechte Dritter durch zur Verf&uuml;gung gestellte
                Unterlagen. Wird die Agentur wegen einer solchen
                Rechtsverletzung von einem Dritten in Anspruch genommen, so
                h&auml;lt der Kunde die Agentur schad- und klaglos; er hat ihr
                s&auml;mtliche Nachteile zu ersetzen, die ihr durch eine
                Inanspruchnahme Dritter entstehen, insbesondere die Kosten einer
                angemessenen rechtlichen Vertretung. Der Kunde verpflichtet
                sich, die Agentur bei der Abwehr von allf&auml;lligen
                Anspr&uuml;chen Dritter zu unterst&uuml;tzen. Der Kunde stellt
                der Agentur hierf&uuml;r unaufgefordert s&auml;mtliche
                Unterlagen zur Verf&uuml;gung.
            </p>
            <p class="p3"><br /></p>

            <h5 class="p4">
                5. &nbsp; &nbsp;Fremdleistungen / Beauftragung Dritter
            </h5>
            <p class="p6">
                5.1 &nbsp; &nbsp;Die Agentur ist nach freiem Ermessen
                berechtigt, die Leistung selbst auszuf&uuml;hren, sich bei der
                Erbringung von vertragsgegenst&auml;ndlichen Leistungen
                sachkundiger Dritter als Erf&uuml;llungsgehilfen zu bedienen
                und/oder derartige Leistungen zu substituieren
                (&bdquo;Fremdleistung&ldquo;).
            </p>
            <p class="p6">
                5.2 &nbsp; &nbsp;Die Beauftragung von Dritten im Rahmen einer
                Fremdleistung erfolgt entweder im eigenen Namen oder im Namen
                des Kunden. Die Agentur wird diesen Dritten sorgf&auml;ltig
                ausw&auml;hlen und darauf achten, dass dieser &uuml;ber die
                erforderliche fachliche Qualifikation verf&uuml;gt.
            </p>
            <p class="p4">
                5.3 &nbsp; &nbsp;In Verpflichtungen gegen&uuml;ber Dritten, die
                &uuml;ber die Vertragslaufzeit hinausgehen, hat der Kunde
                einzutreten. Das gilt ausdr&uuml;cklich auch im Falle einer
                K&uuml;ndigung des Agenturvertrages aus wichtigem Grund.
            </p>
            <p class="p5"><br /></p>

            <h5 class="p4">6. &nbsp; &nbsp;Termine</h5>
            <p class="p6">
                6.1 &nbsp; &nbsp;Angegebene Liefer- oder Leistungsfristen
                gelten, sofern nicht ausdr&uuml;cklich als verbindlich
                vereinbart, nur als ann&auml;hernd und unverbindlich.
                Verbindliche Terminabsprachen sind schriftlich festzuhalten bzw.
                von der Agentur schriftlich zu best&auml;tigen.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p6">
                6.2 &nbsp; &nbsp;Verz&ouml;gert sich die Lieferung/Leistung der
                Agentur aus Gr&uuml;nden, die sie nicht zu vertreten hat, wie
                z.B. Ereignisse h&ouml;herer Gewalt und andere unvorhersehbare,
                mit zumutbaren Mitteln nicht abwendbare Ereignisse, ruhen die
                Leistungsverpflichtungen f&uuml;r die Dauer und im Umfang des
                Hindernisses und verl&auml;ngern sich die Fristen entsprechend.
                Sofern solche Verz&ouml;gerungen mehr als zwei Monate andauern,
                sind der Kunde und die Agentur berechtigt, vom Vertrag
                zur&uuml;ckzutreten.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p4">
                6.3 &nbsp; &nbsp;Befindet sich die Agentur in Verzug, so kann
                der Kunde vom Vertrag nur zur&uuml;cktreten, nachdem er der
                Agentur schriftlich eine angemessene Nachfrist von zumindest 14
                Tagen gesetzt hat und diese fruchtlos verstrichen ist.
                Schadenersatzanspr&uuml;che des Kunden wegen Nichterf&uuml;llung
                oder Verzug sind ausgeschlossen, ausgenommen bei Nachweis von
                Vorsatz oder grober Fahrl&auml;ssigkeit.
            </p>
            <p class="p3"><br /></p>

            <h5 class="p4">7. &nbsp; &nbsp;Vorzeitige Aufl&ouml;sung</h5>
            <p class="p6">
                7.1 &nbsp; &nbsp;Die Agentur ist berechtigt, den Vertrag aus
                wichtigen Gr&uuml;nden mit sofortiger Wirkung aufzul&ouml;sen.
                Ein wichtiger Grund liegt insbesondere vor, wenn
            </p>
            <p class="p10">
                a) &nbsp; &nbsp;die Ausf&uuml;hrung der Leistung aus
                Gr&uuml;nden, die der Kunde zu vertreten hat, unm&ouml;glich
                wird oder trotz Setzung einer Nachfrist von 14 Tagen weiter
                verz&ouml;gert wird;
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p10">
                b) &nbsp; &nbsp;der Kunde fortgesetzt, trotz schriftlicher
                Abmahnung mit einer Nachfristsetzung von 14 Tagen, gegen
                wesentliche Verpflichtungen aus diesem Vertrag, wie z.B. Zahlung
                eines f&auml;llig gestellten Betrages oder Mitwirkungspflichten,
                verst&ouml;&szlig;t.
            </p>
            <p class="p10">
                c) &nbsp; &nbsp;berechtigte Bedenken hinsichtlich der
                Bonit&auml;t des Kunden bestehen und dieser auf Begehren der
                Agentur weder Vorauszahlungen leistet noch vor Leistung der
                Agentur eine taugliche Sicherheit leistet;
            </p>
            <p class="p6">
                7.2 &nbsp; &nbsp;Der Kunde ist berechtigt, den Vertrag aus
                wichtigen Gr&uuml;nden ohne Nachfristsetzung aufzul&ouml;sen.
                Ein wichtiger Grund liegt insbesondere dann vor, wenn die
                Agentur fortgesetzt, trotz schriftlicher Abmahnung mit einer
                angemessenen Nachfrist von zumindest 14 Tagen zur Behebung des
                Vertragsversto&szlig;es gegen wesentliche Bestimmungen aus
                diesem Vertrag verst&ouml;&szlig;t.
            </p>
            <p class="p3"><br /></p>

            <h5 class="p4">8. &nbsp; &nbsp;Honorar</h5>
            <p class="p6">
                8.1 &nbsp; &nbsp;Wenn nichts anderes vereinbart ist, entsteht
                der Honoraranspruch der Agentur f&uuml;r jede einzelne Leistung,
                sobald diese erbracht wurde. Die Agentur ist berechtigt, zur
                Deckung ihres Aufwandes Vorsch&uuml;sse zu verlangen. Ab einem
                Auftragsvolumen mit einem (j&auml;hrlichen) Budget von &euro;
                1500, oder solchen, die sich &uuml;ber einen l&auml;ngeren
                Zeitraum erstrecken ist die Agentur berechtigt,
                Zwischenabrechnungen bzw. Vorausrechnungen zu erstellen oder
                Akontozahlungen abzurufen.
            </p>
            <p class="p6">
                8.2 &nbsp; &nbsp;Das Honorar versteht sich als Netto-Honorar
                zuz&uuml;glich der Umsatzsteuer in gesetzlicher H&ouml;he.
                Mangels Vereinbarung im Einzelfall hat die Agentur f&uuml;r die
                erbrachten Leistungen und die &Uuml;berlassung der urheber- und
                kennzeichenrechtlichen Nutzungsrechte Anspruch auf Honorar in
                der markt&uuml;blichen H&ouml;he.
            </p>
            <p class="p6">
                8.3 &nbsp; &nbsp;Alle Leistungen der Agentur, die nicht
                ausdr&uuml;cklich durch das vereinbarte Honorar abgegolten sind,
                werden gesondert entlohnt. Alle der Agentur erwachsenden
                Barauslagen sind vom Kunden zu ersetzen.
            </p>
            <p class="p6">
                8.4 &nbsp; &nbsp;Kostenvoranschl&auml;ge der Agentur sind
                unverbindlich. Wenn abzusehen ist, dass die tats&auml;chlichen
                Kosten die von der Agentur schriftlich veranschlagten um mehr
                als 15 % &uuml;bersteigen, wird die Agentur den Kunden auf die
                h&ouml;heren Kosten hinweisen. Die Kosten&uuml;berschreitung
                gilt als vom Kunden genehmigt, wenn der Kunde nicht binnen drei
                Werktagen nach diesem Hinweis schriftlich widerspricht und
                gleichzeitig kosteng&uuml;nstigere Alternativen bekannt gibt.
                Handelt es sich um eine Kosten&uuml;berschreitung bis 15 % ist
                eine gesonderte Verst&auml;ndigung nicht erforderlich. Diese
                Kostenvoranschlags&uuml;berschreitung gilt vom Auftraggeber von
                vornherein als genehmigt.
            </p>
            <p class="p4">
                8.5 &nbsp; &nbsp;Wenn der Kunde in Auftrag gegebene Arbeiten
                ohne Einbindung der Agentur - unbeschadet der laufenden
                sonstigen Betreuung durch diese - einseitig &auml;ndert oder
                abbricht, hat er der Agentur die bis dahin erbrachten Leistungen
                entsprechend der Honorarvereinbarung zu verg&uuml;ten und alle
                angefallenen Kosten zu erstatten. Sofern der Abbruch nicht durch
                eine grob fahrl&auml;ssige oder vors&auml;tzliche
                Pflichtverletzung der Agentur begr&uuml;ndet ist, hat der Kunde
                der Agentur dar&uuml;ber hinaus das gesamte f&uuml;r diesen
                Auftrag vereinbarte Honorar (Provision) zu erstatten, wobei die
                Anrechnungsverg&uuml;tung des &sect; 1168 AGBG ausgeschlossen
                wird. Weiters ist die Agentur bez&uuml;glich allf&auml;lliger
                Anspr&uuml;che Dritter, insbesondere von Auftragnehmern der
                Agentur, schad- und klaglos zu stellen. Mit der Bezahlung des
                Entgelts erwirbt der Kunde an bereits erbrachten Arbeiten
                keinerlei Nutzungsrechte; nicht ausgef&uuml;hrte Konzepte,
                Entw&uuml;rfe und sonstige Unterlagen sind vielmehr
                unverz&uuml;glich der Agentur zur&uuml;ckzustellen.
            </p>
            <p class="p5"><br /></p>

            <h5 class="p4">9. &nbsp; &nbsp;Zahlung, Eigentumsvorbehalt</h5>
            <p class="p6">
                9.1 &nbsp; &nbsp;Das Honorar ist sofort mit Rechnungserhalt und
                ohne Abzug zur Zahlung f&auml;llig, sofern nicht im Einzelfall
                besondere Zahlungsbedingungen schriftlich vereinbart werden.
                Dies gilt auch f&uuml;r die Weiterverrechnung s&auml;mtlicher
                Barauslagen und sonstiger Aufwendungen. Die von der Agentur
                gelieferte Ware bleibt bis zur vollst&auml;ndigen Bezahlung des
                Entgelts einschlie&szlig;lich aller Nebenverbindlichkeiten im
                Eigentum der Agentur.
            </p>
            <p class="p6">
                9.2 &nbsp; &nbsp;Bei Zahlungsverzug des Kunden gelten die
                gesetzlichen Verzugszinsen in der f&uuml;r
                Unternehmergesch&auml;fte geltenden H&ouml;he. Weiters
                verpflichtet sich der Kunde f&uuml;r den Fall des
                Zahlungsverzugs, der Agentur die entstehenden Mahn- und
                Inkassospesen, soweit sie zur zweckentsprechenden
                Rechtsverfolgung notwendig sind, zu ersetzen. Dies umfasst
                jedenfalls die Kosten zweier Mahnschreiben in markt&uuml;blicher
                H&ouml;he von derzeit zumindest &euro; 20,00 je Mahnung sowie
                eines Mahnschreibens eines mit der Eintreibung beauftragten
                Rechtsanwalts. Die Geltendmachung weitergehender Rechte und
                Forderungen bleibt davon unber&uuml;hrt.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p6">
                9.3 &nbsp; &nbsp;Im Falle des Zahlungsverzuges des Kunden kann
                die Agentur s&auml;mtliche, im Rahmen anderer mit dem Kunden
                abgeschlossener Vertr&auml;ge, erbrachten Leistungen und
                Teilleistungen sofort f&auml;llig stellen.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p6">
                9.4 &nbsp; &nbsp;Weiters ist die Agentur nicht verpflichtet,
                weitere Leistungen bis zur Begleichung des aushaftenden Betrages
                zu erbringen (Zur&uuml;ckbehaltungsrecht). Die Verpflichtung zur
                Entgeltzahlung bleibt davon unber&uuml;hrt.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p6">
                9.5 &nbsp; &nbsp;Wurde die Bezahlung in Raten vereinbart, so
                beh&auml;lt sich die Agentur f&uuml;r den Fall der nicht
                fristgerechten Zahlung von Teilbetr&auml;gen oder
                Nebenforderungen das Recht vor, die sofortige Bezahlung der
                gesamten noch offenen Schuld zu fordern (Terminverlust).
            </p>
            <p class="p4">
                9.6 &nbsp; &nbsp;Der Kunde ist nicht berechtigt, mit eigenen
                Forderungen gegen Forderungen der Agentur aufzurechnen,
                au&szlig;er die Forderung des Kunden wurde von der Agentur
                schriftlich anerkannt oder gerichtlich festgestellt.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p3"><br /></p>

            <h5 class="p4">10. &nbsp; &nbsp;Eigentumsrecht und Urheberrecht</h5>
            <p class="p6">
                10.1 &nbsp; &nbsp;Alle Leistungen der Agentur,
                einschlie&szlig;lich jener aus Pr&auml;sentationen (z.B.
                Anregungen, Ideen, Skizzen, Vorentw&uuml;rfe, Skribbles,
                Reinzeichnungen, Konzepte, Negative, Dias), auch einzelne Teile
                daraus, bleiben ebenso wie die einzelnen Werkst&uuml;cke und
                Entwurfsoriginale im Eigentum der Agentur und k&ouml;nnen von
                der Agentur jederzeit - insbesondere bei Beendigung des
                Vertragsverh&auml;ltnisses - zur&uuml;ckverlangt werden. Der
                Kunde erwirbt durch Zahlung des Honorars das Recht der Nutzung
                f&uuml;r den vereinbarten Verwendungszweck. Mangels
                anderslautender Vereinbarung darf der Kunde die Leistungen der
                Agentur jedoch ausschlie&szlig;lich in &Ouml;sterreich nutzen.
                Der Erwerb von Nutzungs- und Verwertungsrechten an Leistungen
                der Agentur setzt in jedem Fall die vollst&auml;ndige Bezahlung
                der von der Agentur daf&uuml;r in Rechnung gestellten Honorare
                voraus. Nutzt der Kunde bereits vor diesem Zeitpunkt die
                Leistungen der Agentur, so beruht diese Nutzung auf einem
                jederzeit widerrufbaren Leihverh&auml;ltnis.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p6">
                10.2 &nbsp; &nbsp;&Auml;nderungen bzw. Bearbeitungen von
                Leistungen der Agentur, wie insbesondere deren Weiterentwicklung
                durch den Kunden oder durch f&uuml;r diesen t&auml;tige Dritte,
                sind nur mit ausdr&uuml;cklicher Zustimmung der Agentur und -
                soweit die Leistungen urheberrechtlich gesch&uuml;tzt sind - des
                Urhebers zul&auml;ssig.
            </p>
            <p class="p6">
                10.3 &nbsp; &nbsp;F&uuml;r die Nutzung von Leistungen der
                Agentur, die &uuml;ber den urspr&uuml;nglich vereinbarten Zweck
                und Nutzungsumfang hinausgeht, ist - unabh&auml;ngig davon, ob
                diese Leistung urheberrechtlich gesch&uuml;tzt ist - die
                Zustimmung der Agentur erforderlich. Daf&uuml;r steht der
                Agentur und dem Urheber eine gesonderte angemessene
                Verg&uuml;tung zu.
            </p>
            <p class="p6">
                10.4 &nbsp; &nbsp;F&uuml;r die Nutzung von Leistungen der
                Agentur bzw. von Werbemitteln, f&uuml;r die die Agentur
                konzeptionelle oder gestalterische Vorlagen erarbeitet hat, ist
                nach Ablauf des Agenturvertrages unabh&auml;ngig davon, ob diese
                Leistung urheberrechtlich gesch&uuml;tzt ist oder nicht,
                ebenfalls die Zustimmung der Agentur notwendig.
            </p>
            <p class="p6">
                10.5 &nbsp; &nbsp;F&uuml;r Nutzungen gem&auml;&szlig; Abs 4.
                steht der Agentur im 1. Jahr nach Vertragsende ein Anspruch auf
                die volle im abgelaufenen Vertrag vereinbarte
                Agenturverg&uuml;tung zu. Im 2. bzw. 3. Jahr nach Ablauf des
                Vertrages nur mehr die H&auml;lfte bzw. ein Viertel der im
                Vertrag vereinbarten Verg&uuml;tung. Ab dem 4. Jahr nach
                Vertragsende ist keine Agenturverg&uuml;tung mehr zu zahlen.
            </p>
            <p class="p4">
                10.6 &nbsp; &nbsp;Der Kunde haftet der Agentur f&uuml;r jede
                widerrechtliche Nutzung in doppelter H&ouml;he des f&uuml;r
                diese Nutzung angemessenen Honorars.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p3"><br /></p>

            <h5 class="p4">11. &nbsp; &nbsp;Kennzeichnung</h5>
            <p class="p6">
                11.1 &nbsp; &nbsp;Die Agentur ist berechtigt, auf allen
                Werbemitteln und bei allen Werbema&szlig;nahmen auf die Agentur
                und allenfalls auf den Urheber hinzuweisen, ohne dass dem Kunden
                daf&uuml;r ein Entgeltanspruch zusteht.
            </p>
            <p class="p4">
                11.2 &nbsp; &nbsp;Die Agentur ist vorbehaltlich des jederzeit
                m&ouml;glichen, schriftlichen Widerrufs des Kunden dazu
                berechtigt, auf eigenen Werbetr&auml;gern und insbesondere auf
                ihrer Internet-Website mit Namen und Firmenlogo auf die zum
                Kunden bestehende oder vormalige Gesch&auml;ftsbeziehung
                hinzuweisen (Referenzhinweis).
            </p>
            <p class="p3"><br /></p>

            <h5 class="p4">
                12. &nbsp; &nbsp;Gew&auml;hrleistung
                <span class="Apple-converted-space">&nbsp;</span>
            </h5>
            <p class="p6">
                12.1 &nbsp; &nbsp;Der Kunde hat allf&auml;llige M&auml;ngel
                unverz&uuml;glich, jedenfalls innerhalb von acht Tagen nach
                Lieferung/Leistung durch die Agentur, verdeckte M&auml;ngel
                innerhalb von acht Tagen nach Erkennen derselben, schriftlich
                unter Beschreibung des Mangels anzuzeigen; andernfalls gilt die
                Leistung als genehmigt. In diesem Fall ist die Geltendmachung
                von Gew&auml;hrleistungs- und Schadenersatzanspr&uuml;chen sowie
                das Recht auf Irrtumsanfechtung aufgrund von M&auml;ngeln
                ausgeschlossen.
            </p>
            <p class="p6">
                12.2 &nbsp; &nbsp;Im Fall berechtigter und rechtzeitiger
                M&auml;ngelr&uuml;ge steht dem Kunden das Recht auf Verbesserung
                oder Austausch der Lieferung/Leistung durch die Agentur zu. Die
                Agentur wird die M&auml;ngel in angemessener Frist beheben,
                wobei der Kunde der Agentur alle zur Untersuchung und
                M&auml;ngelbehebung erforderlichen Ma&szlig;nahmen
                erm&ouml;glicht. Die Agentur ist berechtigt, die Verbesserung
                der Leistung zu verweigern, wenn diese unm&ouml;glich oder
                f&uuml;r die Agentur mit einem unverh&auml;ltnism&auml;&szlig;ig
                hohen Aufwand verbunden ist. In diesem Fall stehen dem Kunden
                die gesetzlichen Wandlungs- oder Minderungsrechte zu. Im Fall
                der Verbesserung obliegt es dem Auftraggeber die
                &Uuml;bermittlung der mangelhaften (k&ouml;rperlichen) Sache auf
                seine Kosten durchzuf&uuml;hren.
            </p>
            <p class="p6">
                12.3 &nbsp; &nbsp;Es obliegt auch dem Auftraggeber, die
                &Uuml;berpr&uuml;fung der Leistung auf ihre rechtliche,
                insbesondere wettbewerbs-, marken-, urheber- und
                verwaltungsrechtliche Zul&auml;ssigkeit durchzuf&uuml;hren. Die
                Agentur ist nur zu einer Grobpr&uuml;fung der rechtlichen
                Zul&auml;ssigkeit verpflichtet. Die Agentur haftet im Falle
                leichter Fahrl&auml;ssigkeit oder nach Erf&uuml;llung einer
                allf&auml;lligen Warnpflicht gegen&uuml;ber dem Kunden nicht
                f&uuml;r die rechtliche Zul&auml;ssigkeit von Inhalten, wenn
                diese vom Kunden vorgegeben oder genehmigt wurden.
            </p>
            <p class="p4">
                12.4 &nbsp; &nbsp;Die Gew&auml;hrleistungsfrist betr&auml;gt
                sechs Monate ab Lieferung/Leistung. Das Recht zum Regress
                gegen&uuml;ber der Agentur gem&auml;&szlig; &sect; 933b Abs 1
                ABGB erlischt ein Jahr nach Lieferung/Leistung. Der Kunde ist
                nicht berechtigt, Zahlungen wegen Bem&auml;ngelungen
                zur&uuml;ckzuhalten. Die Vermutungsregelung des &sect; 924 ABGB
                wird ausgeschlossen.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p11"><br /></p>

            <h5 class="p12">13. &nbsp; &nbsp;Haftung und Produkthaftung</h5>
            <p class="p4">
                13.1 &nbsp; &nbsp;In F&auml;llen leichter Fahrl&auml;ssigkeit
                ist eine Haftung der Agentur und die ihrer Angestellten,
                Auftragnehmer oder sonstigen Erf&uuml;llungsgehilfen
                (&bdquo;Leute&ldquo;) f&uuml;r Sach- oder
                Verm&ouml;genssch&auml;den des Kunden ausgeschlossen,
                gleichg&uuml;ltig ob es sich um unmittelbare oder mittelbare
                Sch&auml;den, entgangenen Gewinn oder Mangelfolgesch&auml;den,
                Sch&auml;den wegen Verzugs, Unm&ouml;glichkeit, positiver
                Forderungsverletzung, Verschuldens bei Vertragsabschluss, wegen
                mangelhafter oder unvollst&auml;ndiger Leistung handelt. Das
                Vorliegen von grober Fahrl&auml;ssigkeit hat der
                Gesch&auml;digte zu beweisen. Soweit die Haftung der Agentur
                ausgeschlossen oder beschr&auml;nkt ist, gilt dies auch f&uuml;r
                die pers&ouml;nliche Haftung ihrer &bdquo;Leute&ldquo;.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p7">
                13.2 &nbsp; &nbsp;Jegliche Haftung der Agentur f&uuml;r
                Anspr&uuml;che, die auf Grund der von der Agentur erbrachten
                Leistung (z.B. Werbema&szlig;nahme) gegen den Kunden erhoben
                werden, wird ausdr&uuml;cklich ausgeschlossen, wenn die Agentur
                ihrer Hinweispflicht nachgekommen ist oder eine solche f&uuml;r
                sie nicht erkennbar war, wobei leichte Fahrl&auml;ssigkeit nicht
                schadet. Insbesondere haftet die Agentur nicht f&uuml;r
                Prozesskosten, eigene Anwaltskosten des Kunden oder Kosten von
                Urteilsver&ouml;ffentlichungen sowie f&uuml;r allf&auml;llige
                Schadenersatzforderungen oder sonstige Anspr&uuml;che Dritter;
                der Kunde hat die Agentur diesbez&uuml;glich schad- und klaglos
                zu halten.
            </p>
            <p class="p12">
                13.3 &nbsp; &nbsp;Schadensersatzanspr&uuml;che des Kunden
                verfallen in sechs Monaten ab Kenntnis des Schadens; jedenfalls
                aber nach drei Jahren ab der Verletzungshandlung der Agentur.
                Schadenersatzanspr&uuml;che sind der H&ouml;he nach mit dem
                Netto-Auftragswert begrenzt.
            </p>
            <p class="p14"><br /></p>

            <h5 class="p12">
                <strong>
                    14. &nbsp; &nbsp;Datenschutz
                    <br />
                </strong>
            </h5>
            <p class="p15">
                Der Kunde stimmt zu, dass seine pers&ouml;nlichen Daten,
                n&auml;mlich Name/Firma, Beruf, Geburtsdatum, Firmenbuchnummer,
                Vertretungsbefugnisse, Ansprechperson, Gesch&auml;ftsanschrift
                und sonstige Adressen des Kunden, Telefonnummer, Telefaxnummer,
                E-Mail-Adresse, Bankverbindungen, Kreditkartendaten, UID-Nummer)
                zum Zwecke der Vertragserf&uuml;llung und Betreuung des Kunden
                sowie f&uuml;r eigene Werbezwecke, beispielsweise zur Zusendung
                von Angeboten, Werbeprospekten und Newsletter (in Papier- und
                elektronischer Form), sowie zum Zwecke des Hinweises auf die zum
                Kunden bestehende oder vormalige Gesch&auml;ftsbeziehung
                (Referenzhinweis) automationsunterst&uuml;tzt ermittelt,
                gespeichert und verarbeitet werden.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p15">
                <strong>
                    Der Auftraggeber ist einverstanden, dass ihm elektronische
                    Post zu Werbezwecken bis auf Widerruf zugesendet wird.
                    <span class="Apple-converted-space">&nbsp;</span>
                </strong>
            </p>
            <p class="p15">
                <strong>
                    Diese Zustimmung kann jederzeit schriftlich mittels E-Mail,
                    Telefax oder Brief an die im Kopf der AGB angef&uuml;hrten
                    Kontaktdaten widerrufen werden.
                </strong>
            </p>
            <p class="p17"><br /></p>

            <h5 class="p12">15. &nbsp; &nbsp;Anzuwendendes Recht</h5>
            <p class="p18">
                Der Vertrag und alle daraus abgeleiteten wechselseitigen Rechte
                und Pflichten sowie Anspr&uuml;che zwischen der Agentur und dem
                Kunden unterliegen dem &ouml;sterreichischen materiellen Recht
                unter Ausschluss seiner Verweisungsnormen und unter Ausschluss
                des UN-Kaufrechts.
            </p>
            <p class="p11"><br /></p>

            <h5 class="p12">
                16. &nbsp; &nbsp;Erf&uuml;llungsort und Gerichtsstand
            </h5>
            <p class="p19">
                16.1 &nbsp; &nbsp;Erf&uuml;llungsort ist der Sitz der Agentur.
                Bei Versand geht die Gefahr auf den Kunden &uuml;ber, sobald die
                Agentur die Ware dem von ihr gew&auml;hlten
                Bef&ouml;rderungsunternehmen &uuml;bergeben hat.
            </p>
            <p class="p19">
                16.2 &nbsp; &nbsp;Als Gerichtsstand f&uuml;r alle sich zwischen
                der Agentur und dem Kunden ergebenden Rechtsstreitigkeiten im
                Zusammenhang mit diesem Vertragsverh&auml;ltnis wird das
                f&uuml;r den Sitz der Agentur sachlich zust&auml;ndige Gericht
                vereinbart. Ungeachtet dessen ist die Agentur berechtigt, den
                Kunden an seinem allgemeinen Gerichtsstand zu klagen.
            </p>
            <p class="p4">
                16.3
                <span class="Apple-converted-space">&nbsp;&nbsp;</span>
                Soweit in diesem Vertrag auf nat&uuml;rliche Personen bezogene
                Bezeichnungen nur in m&auml;nnlicher Form angef&uuml;hrt sind,
                beziehen sie sich auf Frauen und M&auml;nner in gleicher Weise.
                Bei der Anwendung der Bezeichnung auf bestimmte nat&uuml;rliche
                Personen ist die jeweils geschlechtsspezifische Form zu
                verwenden.
            </p>

            <p class="mt-5">
                <strong>
                    Ergänzende Hinweise zu den Allgemeinen Geschäftsbedingungen
                    für Werbeagenturen
                </strong>
            </p>
            <p class="p20">
                1. Die vom Fachverband Werbung &amp; Marktkommunikation der
                Wirtschaftskammer &Ouml;sterreich herausgegebenen
                &bdquo;Allgemeinen Gesch&auml;ftsbedingungen&ldquo; (AGB) sind
                lediglich ein Muster, welches Anhaltspunkte und Anregungen
                liefern soll. Es ist daher keinesfalls sichergestellt, dass die
                Muster-AGB in allen Details von jedem Kommunikationsunternehmen
                in der vorgeschlagenen Form angewendet werden! Wie jedes Muster
                kann auch das f&uuml;r die AGB entsprechend den konkreten
                Anforderungen des jeweiligen Unternehmens erg&auml;nzt bzw.
                adaptiert werden. Wenn eine Firma beispielsweise nicht nur
                Dienstleistungen erbringt, sondern auch Waren (z.B. Software)
                liefert, werden die AGB h&ouml;chstwahrscheinlich eine
                Eigentumsvorbehaltsklausel enthalten.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p20">
                2. AGB sind vorformulierte Vertragsklauseln, die eine Partei der
                anderen vor Abschluss eines Vertrages vorlegt. Sie werden jedoch
                nicht automatisch in den Vertrag einbezogen und k&ouml;nnen dem
                Vertragspartner auch nicht aufgezwungen werden! Sie gelten nur,
                wenn sie vertraglich vereinbart wurden. Der Vertragspartner bzw.
                Auftraggeber muss daher den von seinem Lieferanten verwendeten
                AGB zustimmen. Die Zustimmung kann auch schl&uuml;ssig erfolgen,
                etwa dadurch, dass der Auftraggeber den AGB (die zum Beispiel
                dem Angebot beigef&uuml;gt waren) nicht widerspricht.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p20">
                Entsprechend der herrschenden Judikatur sind in AGB die
                Datenschutzbestimmungen optisch hervorzuheben. Der Fachverband
                Werbung und Marktkommunikation empfiehlt, diese Text-passagen
                &bdquo;fett&ldquo; zu formatieren.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p20">
                3. Von einer Zustimmung zu den AGB durch den Auftraggeber kann
                nur dann ausgegangen werden, wenn dieser &uuml;berhaupt davon
                gewusst hat, dass sein Lieferant AGB verwendet. In der Regel
                gen&uuml;gt es, wenn der Auftragnehmer den Auftraggeber auf die
                AGB &ndash; schriftlich oder m&uuml;ndlich &ndash; aufmerksam
                macht. Der Hinweis muss allerdings deutlich sein;
                Kleingedrucktes und kaum leserliche Hinweise auf der
                R&uuml;ckseite eines Angebots reichen nicht aus. Bei einem
                Vertragsangebot im Internet kann mit einem Button oder einem
                Link auf die AGB hingewiesen werden.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p20">
                4. Der blo&szlig;e Hinweis auf Allgemeine
                Gesch&auml;ftsbedingungen reicht nicht aus. Der Auftraggeber
                muss vor Vertragsabschluss nachweislich Gelegenheit gehabt
                haben, in die AGB Einsicht zu nehmen! Ob er dann auch
                tats&auml;chlich Einsicht nimmt oder nicht, ist ohne Bedeutung.
                Bei einem Angebot im Internet soll der Vertragspartner auch die
                M&ouml;glichkeit haben, die AGB auszudrucken bzw. zu speichern.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p20">
                5. Wird erst nach Vertragsabschluss auf die AGB verwiesen (z.B.
                auf einem Lieferschein oder einer Rechnung), so ist das zu
                sp&auml;t: Die Allgemeinen Gesch&auml;ftsbedingungen sind dann
                nicht Vertragsbestandteil.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p20">
                6. Falls beide Vertragspartner AGBs verwenden, die einander in
                manchen Punkten widersprechen, liegt keine
                Willens&uuml;bereinstimmung vor, sodass die widersprechenden AGB
                nicht Vertragsbestandteil werden. Betreffen die
                widerspr&uuml;chlichen AGB wichtige Punkte des Vertrages, kann
                im Einzelfall sogar der gesamte Vertrag nicht zustande kommen.
                Es ist daher dringend anzuraten, dass die Vertragspartner eine
                fr&uuml;hzeitige Einigung bez&uuml;glich der
                widerspr&uuml;chlichen Bestimmungen ihrer jeweiligen AGB
                herbeif&uuml;hren.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p20">
                7. Ein g&auml;nzlicher Haftungsausschluss, ein Ausschluss der
                Gew&auml;hrleistung bei mangelhafter Leistungserbringung oder
                &auml;hnliche einseitige Klauseln benachteiligen den jeweils
                anderen Vertragspartner gr&ouml;blich und sind daher
                unzul&auml;ssig i. S. des &sect; 879 Abs. 3 ABGB. Bestehen
                Zweifel an der rechtlichen Unbedenklichkeit vorliegender
                Gesch&auml;ftsbedingungen, ist es ratsam, professionellen
                juristischen Rat in Anspruch zu nehmen.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
            <p class="p20">
                8. Bei einer &ouml;ffentlichen Ausschreibung gibt nur der
                Auftraggeber die AGBs vor. Sollte im Zuge einer
                &ouml;ffentlichen Ausschreibung ein Unternehmer mit anderen als
                vom Auftraggeber geforderten AGBs anbieten, bietet der
                Unternehmer nicht ausschreibungskonform an, was im Regelfall ein
                unbehebbarer Mangel ist und zum Ausscheiden des Unternehmers
                f&uuml;hrt.
                <span class="Apple-converted-space">&nbsp;</span>
            </p>
        </div>
    </div>
</template>

<script lang="ts">
export default defineNuxtComponent({
    name: 'AGBPage',
    head() {
        return {
            title: 'GTC',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content:
                        'AGBs | General Terms & Conditions of Raphael Bernhart',
                },
            ],
        };
    },
});
</script>

<style scoped>
h1 {
    font-size: 4rem;
    font-weight: bold;
    margin: 50px 0 25px 0 !important;
}
h2 {
    font-size: 2.2rem;
    font-weight: bold;
    margin: 40px 0 20px 0 !important;
}
h3 {
    font-size: 1.8rem;
    font-weight: bold;
    margin: 30px 0 15px 0 !important;
}
h4 {
    font-size: 1.5rem;
    font-weight: bold;
    margin: 25px 0 15px 0 !important;
}
h5 {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 20px 0 10px 0 !important;
}
h6 {
    font-size: 1rem;
    font-weight: bold;
    margin: 15px 0 10px 0 !important;
}
a {
    font-weight: 500;
    /* font-style: italic; */
    text-decoration: underline;
}
p {
    line-height: 1.7;
    margin: 10px 0;
}
</style>
